import React from 'react'
/* REDUX */
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { addReply } from '../../actions/replies'

const form = reduxForm({
	form: 'reply',
})

class ReplyForm extends React.Component {
	
	handleSubmit = (formData) => {
		const { authenticated, onLogin, report_id, comment_id, addReply } = this.props
		if (!authenticated) {
			onLogin()
			return
		}
		if (!formData.replyText) {
			alert("Please enter a reply")
			return
		}
		let data = {
			sid: report_id,
			comment: formData.replyText,
			cid: comment_id
		}
		addReply(report_id, comment_id, data)
	}
	
	render() {
		const {handleSubmit} = this.props
		return (
			<form onSubmit={handleSubmit(this.handleSubmit.bind(this))}>
				<div className="form-group">
					<label>Type your reply below</label>
					<Field className="form-control" name="replyText" component="textarea" rows="2"/>
				</div>
				<button type="submit" className="btn btn-comment">Reply</button>
			</form>
		)
	}
}

const mapStateToProps = (state) => {
	const formState = state.form.reply || {}
	const formValues = formState.values
	return {
		formValues,
		authenticated: state.auth.authenticated
	}
}

export default connect(mapStateToProps, { addReply })(form(ReplyForm))


// WEBPACK FOOTER //
// ./src/components/Report/ReplyForm.js